import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles, testimonials, categories, getTopArticle, getLatestArticles } from '@/mocks/articles';

export default function Home() {
  const topArticle = getTopArticle();
  const latestArticles = getLatestArticles(8);
  const featuredArticles = articles.filter((a) => a.isExclusive).slice(0, 2);

  return (
    <>
      <Navbar />

      <main>
        {/* Hero Section */}
        <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20ink%20splash%20and%20watermelon%20slice%20motif%2C%20dark%20olive%20green%20and%20charcoal%20atmosphere%2C%20mysterious%20Chinese%20contemporary%20art%20style%2C%20minimal%20negative%20space%2C%20editorial%20quality%2C%20subtle%20texture%2C%20deep%20moody%20lighting%2C%20clean%20composition%2C%20sophisticated%20aesthetic&width=1600&height=900&seq=hero-bg-home&orientation=landscape"
              alt="五一吃瓜网 - 网红黑料每日爆料"
              title="五一吃瓜网 - 网红黑料每日爆料"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

          <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center">
            <div className="mb-6">
              <div className="inline-flex items-center gap-2 text-background-50/80 text-xs md:text-sm">
                <Link to="/" className="hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
                <span className="text-background-50/50">/</span>
                <span className="text-background-50/70">今日吃瓜</span>
              </div>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-black text-background-50 leading-tight mb-5">
              五一吃瓜网
            </h1>
            <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto mb-10 leading-relaxed">
              每日更新网红黑料、网络热门事件吃瓜爆料，实时追踪塌房现场。最全的娱乐圈八卦一手掌握。
            </p>

            <div className="flex items-center justify-center gap-4 flex-wrap">
              <Link
                to={`/article/${topArticle?.id}`}
                className="px-8 py-3 text-sm font-medium bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
              >
                最新爆料
              </Link>
              <Link
                to={`/category/${categories[0]?.slug}`}
                className="px-8 py-3 text-sm font-medium border border-background-50/60 text-background-50 rounded-full hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer"
              >
                热门分类
              </Link>
            </div>
          </div>
        </section>

        {/* Feature Grid - 今日吃瓜热点精选 */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                今日吃瓜
                <span className="text-accent-500"> 热点精选</span>
              </h2>
              <p className="text-sm text-foreground-500 max-w-xl mx-auto">
                实时追踪最新最劲爆的网红黑料与娱乐圈八卦
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
              {topArticle && (
                <Link
                  to={`/article/${topArticle.id}`}
                  className="lg:row-span-2 relative group rounded-lg overflow-hidden cursor-pointer h-[420px] lg:h-auto"
                >
                  <img
                    src={topArticle.image}
                    alt={topArticle.title}
                    title={topArticle.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5">
                    <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full mb-3 whitespace-nowrap">
                      今日TOP1
                    </span>
                    <h3 className="font-heading text-lg md:text-xl font-bold text-background-50 mb-2 line-clamp-2">
                      {topArticle.title}
                    </h3>
                    <p className="text-sm text-background-50/70 line-clamp-2 mb-3">
                      {topArticle.excerpt}
                    </p>
                    <div className="flex items-center gap-3 text-xs text-background-50/50">
                      <span>{topArticle.publishDate}</span>
                      <span>{topArticle.views.toLocaleString()} 阅读</span>
                    </div>
                  </div>
                </Link>
              )}

              {featuredArticles.map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="relative group rounded-lg overflow-hidden cursor-pointer h-[200px]"
                >
                  <img
                    src={article.image}
                    alt={article.title}
                    title={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                  <div className="absolute top-3 left-3">
                    <span className={`inline-block px-2.5 py-0.5 text-xs font-medium rounded-full whitespace-nowrap ${
                      idx === 0
                        ? 'bg-secondary-500 text-background-50'
                        : 'bg-accent-500 text-background-50'
                    }`}>
                      {article.isExclusive ? '独家爆料' : '热门'}
                    </span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 p-4">
                    <h3 className="font-heading text-sm md:text-base font-bold text-background-50 mb-1 line-clamp-2">
                      {article.title}
                    </h3>
                    <span className="text-xs text-background-50/50">{article.publishDate}</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Grid - 实时滚动爆料 */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center">
                实时滚动爆料
              </h2>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {latestArticles.slice(0, 4).map((article, idx) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    {idx === 0 && (
                      <div className="absolute top-3 left-3">
                        <span className="inline-block px-2.5 py-0.5 text-xs font-medium bg-foreground-900 text-background-50 rounded-full whitespace-nowrap">
                          独家
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span><i className="ri-eye-line mr-1"></i>{article.views.toLocaleString()}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* 更多爆料卡片 */}
        <section className="w-full bg-background-50 pb-16 md:pb-20 -mt-4">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
              {latestArticles.slice(4, 8).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-100 rounded-lg overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-4">
                    <span className="inline-block px-2 py-0.5 text-xs font-medium bg-secondary-100 text-secondary-700 rounded-full mb-2 whitespace-nowrap">
                      {categories.find((c) => c.slug === article.category)?.name || article.category}
                    </span>
                    <h3 className="font-heading text-sm font-bold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span><i className="ri-eye-line mr-1"></i>{article.views.toLocaleString()}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonial - 爆料者证言区 */}
        <section className="w-full py-16 md:py-20 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="relative bg-foreground-900 rounded-2xl overflow-hidden">
              <div className="flex flex-col lg:flex-row">
                <div className="lg:w-1/3 relative">
                  <div className="relative h-80 lg:h-full -mb-12 lg:-mb-0 lg:-ml-12 z-10">
                    <img
                      src={testimonials[0].avatar}
                      alt={testimonials[0].name}
                      className="w-full h-full object-cover object-top rounded-2xl lg:rounded-r-none"
                    />
                  </div>
                </div>
                <div className="lg:w-2/3 flex flex-col justify-center py-10 px-6 md:px-12 lg:pl-16">
                  <div className="mb-6">
                    <span className="text-5xl text-accent-400/40 font-serif leading-none">&ldquo;</span>
                  </div>
                  <p className="text-base md:text-lg text-background-50/90 leading-relaxed mb-6">
                    {testimonials[0].content}
                  </p>
                  <div className="mb-8">
                    <p className="text-sm font-semibold text-background-50">{testimonials[0].name}</p>
                    <p className="text-xs text-background-50/50">{testimonials[0].role}</p>
                  </div>
                  <Link
                    to="/about"
                    className="self-start px-6 py-2.5 text-sm font-medium bg-secondary-500 text-background-50 rounded-full hover:bg-secondary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    我要投稿
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA - 订阅关注区 */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto text-center">
              <div className="mb-10 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Abstract%20modern%20smartphone%20with%20QR%20code%20scanning%20scene%2C%20warm%20soft%20lighting%2C%20minimal%20aesthetic%2C%20dark%20olive%20and%20coral%20color%20accents%2C%20clean%20composition%2C%20contemporary%20editorial%20style%2C%20gentle%20film%20grain%20texture%2C%20cozy%20atmosphere&width=1200&height=600&seq=cta-subscribe&orientation=landscape"
                  alt="扫码关注五一吃瓜网"
                  title="关注五一吃瓜网公众号"
                  className="w-full h-auto object-cover"
                />
              </div>

              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3 leading-snug">
                不错过
                <span className="font-normal italic text-foreground-500"> 每一个</span>
                精彩瞬间
              </h2>
              <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto">
                扫码关注五一吃瓜网公众号，解锁更多独家爆料和隐藏瓜源
              </p>

              <Link
                to="/about"
                className="inline-block px-10 py-3.5 text-sm font-medium bg-foreground-900 text-background-50 rounded-full hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
              >
                立即订阅公众号
              </Link>
            </div>
          </div>
        </section>

        {/* 分类快速入口 */}
        <section className="w-full bg-background-50 py-16 md:py-20">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                探索
                <span className="text-accent-500"> 分类</span>
              </h2>
              <p className="text-sm text-foreground-500">按分类浏览你最感兴趣的吃瓜内容</p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="group bg-background-100 rounded-lg p-5 text-center cursor-pointer hover:bg-background-200/70 transition-colors"
                >
                  <div className="w-14 h-14 mx-auto mb-3 rounded-full overflow-hidden">
                    <img
                      src={cat.image}
                      alt={cat.name}
                      title={cat.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <h3 className="font-heading text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">
                    {cat.name}
                  </h3>
                  <p className="text-xs text-foreground-400">{cat.count.toLocaleString()} 条爆料</p>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="w-full bg-background-100 py-16 md:py-20">
          <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
                常见
                <span className="text-accent-500"> 问题</span>
              </h2>
            </div>

            <div className="space-y-3">
              {[
                { q: '五一吃瓜网是什么？', a: '五一吃瓜网是一个专注于网红黑料、网络热门事件和娱乐圈八卦的内容平台，每日更新最新爆料，为吃瓜群众提供最全面、最及时的热点追踪服务。' },
                { q: '如何获取五一吃瓜网的最新地址？', a: '关注我们的微信公众号或加入粉丝社群，即可随时获取五一吃瓜网的最新入口地址，确保你不会错过任何精彩内容。' },
                { q: '五一吃瓜网的内容多久更新一次？', a: '我们保持每日更新的频率，重大热点事件发生后30分钟内即可上线相关报道，确保你第一时间吃到最新鲜的瓜。' },
                { q: '如何向五一吃瓜网投稿爆料？', a: '欢迎通过"关于我们"页面的投稿通道提交你的一手爆料信息。我们承诺严格保护爆料人的隐私，关键信息可做匿名处理。' },
                { q: '五一吃瓜网的内容可信吗？', a: '我们坚持多方核实、交叉验证的原则，所有爆料内容均经过编辑团队的严格审核，标注信息来源，确保内容的真实性和可靠性。' },
              ].map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-lg overflow-hidden">
                  <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                    <span className="font-heading text-sm md:text-base font-semibold text-foreground-900">
                      {faq.q}
                    </span>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0 ml-3">
                      <i className="ri-arrow-down-s-line text-foreground-500 group-open:hidden"></i>
                      <i className="ri-arrow-up-s-line text-foreground-500 hidden group-open:block"></i>
                    </span>
                  </summary>
                  <div className="px-5 pb-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />

      {/* Schema.org */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebPage",
          "name": "五一吃瓜网 - 首页",
          "description": "五一吃瓜网官网入口，每日更新网红黑料、网络热门事件吃瓜爆料，实时追踪塌房现场",
          "url": "http://91yingba.cn/",
          "breadcrumb": {
            "@type": "BreadcrumbList",
            "itemListElement": [
              { "@type": "ListItem", "position": 1, "name": "首页", "item": "http://91yingba.cn/" }
            ]
          }
        })
      }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{
        __html: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            { "@type": "Question", "name": "五一吃瓜网是什么？", "acceptedAnswer": { "@type": "Answer", "text": "五一吃瓜网是一个专注于网红黑料、网络热门事件和娱乐圈八卦的内容平台，每日更新最新爆料，为吃瓜群众提供最全面、最及时的热点追踪服务。" } },
            { "@type": "Question", "name": "如何获取五一吃瓜网的最新地址？", "acceptedAnswer": { "@type": "Answer", "text": "关注我们的微信公众号或加入粉丝社群，即可随时获取五一吃瓜网的最新入口地址。" } },
            { "@type": "Question", "name": "五一吃瓜网的内容多久更新一次？", "acceptedAnswer": { "@type": "Answer", "text": "我们保持每日更新的频率，重大热点事件发生后30分钟内即可上线相关报道。" } },
            { "@type": "Question", "name": "如何向五一吃瓜网投稿爆料？", "acceptedAnswer": { "@type": "Answer", "text": "欢迎通过关于我们页面的投稿通道提交你的一手爆料信息。我们承诺严格保护爆料人的隐私。" } },
            { "@type": "Question", "name": "五一吃瓜网的内容可信吗？", "acceptedAnswer": { "@type": "Answer", "text": "我们坚持多方核实、交叉验证的原则，所有爆料内容均经过编辑团队的严格审核，确保内容的真实性和可靠性。" } },
          ]
        })
      }} />
    </>
  );
}